export class OrigenPagoBeneficiario {

    model = {
        id: { value: null, header: 'Código' },
        detalle_actividad: {
            value: '', header: 'Los valores entregados provienen de (detalle actividad económica o fuente):',
            maxLength: 'Máximo 1000 caracteres', minLength: 'Mínimo 4 caracteres', max: 100, min: 4,
            required: 'Detalle de valores entregados es requerido.'
        },
        tipo_entrega: { value: null, header: 'Los valores entregados son:', required: 'Valor entregado es requerido' },
        forma_pago: { value: null, header: 'Tipo de pago:', required: 'Tipo de pago es requerido' },
    }

    optionLabel = 'nombre';
}
